<template>
  <div class="contactUsPage">
    <head-top></head-top>
    <div class="banner">
      <h3>联系我们</h3>
      <p>商鼎云持续在电商领域深耕</p>
    </div>
    <section class="contactUsBox">
      <div class="fillContactBox">
        <h3>留下您的联系方式 更有效的为您服务</h3>
        <div class="inputBox">
          <input type="text" placeholder="*您的姓名" v-model="name">
          <input type="text" placeholder="*您的电话" v-model="phone">
          <textarea placeholder="请描述您的软件需求,3分钟获得项目报价" v-model="contact"></textarea>
          <button @click="onSubmit">确认提交</button>
        </div>
      </div>
      <div class="companyAddress">
        <div>
          <label>公司地址：</label>
          <p>广东省深圳市宝安区西乡街道金海路汇潮科技大厦602~603室（西乡地铁B出口往前200米）</p>
        </div>
        <div>
          <label>邮箱：</label>
          <p>shangdingyun@126.com</p>
        </div>
        <div>
          <label>服务电话：</label>
          <p>18026947612</p>
        </div>
      </div>
    </section>
    <section class="map">
      <img src="">
    </section>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: "",
      name: "",
      contact: "",
      need: "",
      statisticsState: ""
    };
  },
  methods: {
    onSubmit() {
      if (this.name == "") {
        this.prompt("请填写您的称呼");
        return;
      }
      if (this.phone == "") {
        this.prompt("请填写您的手机号，方便我们联系您");
        return;
      }
      if (!/^[1][0-9]{10}$/.test(this.phone)) {
        this.prompt("您填写的手机号格式不正确");
        return;
      }
      let httpData = {
        phone: this.phone,
        nickName: this.name,
        companyName: "商鼎云技术集团有限公司"
      };
      if (this.contact) {
        httpData.wx = this.contact;
      }
      if (this.need) {
        httpData.needDesc = this.need;
      }
      this.$ajax
        .post("api/user_need/submit", httpData)
        .then(data => {
          this.phone = "";
          this.name = "";
          this.contact = "";
          this.need = "";
          this.$alert("信息已提交，稍后客服会联系您，请保持电话畅通！");
        });
    }
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
.contactUsPage {
  background-color: #fff;
}
.banner {
  background-image: url("https://qn.kemean.cn/upload/201809/06/54027b72d3674e23a6a5276cce4dc0cb");
}
@media screen and (min-width: 1200px) {
  .contactUsBox {
    max-width: 1200px;
    width: 100%;
    margin: -80px auto 0px auto;
    background-color: #fff;
    box-shadow: 3px 5px 19px 1px rgba(142, 142, 142, 0.08);
    display: flex;
    .fillContactBox {
      width: 55%;
      padding: 44px 60px;
      h3 {
        font-size: 30px;
        color: #282129;
      }
      .inputBox {
        padding: 0px 40px;
        margin-top: 40px;
        text-align: center;
        input {
          display: block;
          width: 100%;
          height: 62px;
          background-color: #e9e9e9;
          padding: 0 20px;
          margin-bottom: 38px;
        }
        textarea {
          display: block;
          width: 100%;
          height: 221px;
          background-color: #e9e9e9;
          padding: 20px;
          margin-bottom: 38px;
          max-width: 100%;
          resize: none;
        }
        button {
          width: 183px;
          height: 63px;
          background-color: #1b8ffc;
          border-radius: 31px;
          font-size: 30px;
          color: #ffffff;
        }
      }
    }
    .companyAddress {
      @include bis(
        "https://qn.kemean.cn/upload/201809/06/6b1761127ee3477786342506b62e6a9d"
      );
      width: 45%;
      background-size: 100% 100%;
      padding: 150px 95px;
      div {
        margin-bottom: 30px;
        label {
          font-size: 26px;
          color: #282129;
          font-weight: bold;
        }
        p {
          font-size: 18px;
          color: #282129;
          margin-top: 10px;
        }
      }
    }
  }
  .map {
    margin-top: 53px;
    display: flex;
    justify-content: center;
    width: 100%;
    overflow: hidden;
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .contactUsBox {
    width: 100%;
    background-color: #fff;
    box-shadow: 3px 5px 19px 1px rgba(142, 142, 142, 0.08);
    display: flex;
    .fillContactBox {
      width: 55%;
      padding: 3vw 5vw;
      h3 {
        font-size: 2.6vw;
        color: #282129;
      }
      .inputBox {
        padding: 0px 3.6vw;
        margin-top: 3.5vw;
        text-align: center;
        input {
          display: block;
          width: 100%;
          height: 5.4vw;
          background-color: #e9e9e9;
          padding: 0 1.5vw;
          margin-bottom: 3vw;
        }
        textarea {
          display: block;
          width: 100%;
          height: 18vw;
          background-color: #e9e9e9;
          padding: 1.6vw;
          margin-bottom: 3vw;
          max-width: 100%;
          resize: none;
        }
        button {
          width: 17vw;
          height: 5vw;
          background-color: #1b8ffc;
          border-radius: 2.5vw;
          font-size: 2.5vw;
          color: #ffffff;
        }
      }
    }
    .companyAddress {
      @include bis(
        "https://qn.kemean.cn/upload/201809/06/6b1761127ee3477786342506b62e6a9d"
      );
      width: 45%;
      background-size: 100% 100%;
      padding: 13vw 8vw;
      div {
        margin-bottom: 2.5vw;
        label {
          font-size: 2vw;
          color: #282129;
          font-weight: bold;
        }
        p {
          font-size: 1.6vw;
          color: #282129;
          margin-top: 0.7vw;
        }
      }
    }
  }
  .map {
    margin-top: 5vw;
    width: 100%;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
}
@media screen and (max-width: 750px) {
  .contactUsBox {
    width: 100%;
    background-color: #fff;
    box-shadow: 3px 5px 19px 1px rgba(142, 142, 142, 0.08);
    .fillContactBox {
      width: 100%;
      padding: 3vw 5vw;
      h3 {
        font-size: 4vw;
        color: #282129;
      }
      .inputBox {
        margin-top: 3.5vw;
        text-align: center;
        input {
          display: block;
          width: 100%;
          height: 9vw;
          background-color: #e9e9e9;
          padding: 0 3vw;
          margin-bottom: 4vw;
        }
        textarea {
          display: block;
          width: 100%;
          height: 23vw;
          background-color: #e9e9e9;
          padding: 3vw;
          margin-bottom: 4vw;
          max-width: 100%;
          resize: none;
        }
        button {
          width: 30vw;
          height: 10vw;
          background-color: #1b8ffc;
          border-radius: 2.5vw;
          font-size: 3.6vw;
          color: #ffffff;
        }
      }
    }
    .companyAddress {
      @include bis(
        "https://qn.kemean.cn/upload/201809/06/6b1761127ee3477786342506b62e6a9d"
      );
      width: 100%;
      background-size: 100% 100%;
      padding: 13vw 8vw;
      div {
        margin-bottom: 3vw;
        label {
          font-size: 4.2vw;
          color: #282129;
          font-weight: bold;
        }
        p {
          font-size: 3.6vw;
          color: #282129;
          margin-top: 1.2vw;
        }
      }
    }
  }
  .map {
    margin-top: 3vw;
    width: 100%;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
